export default "__VITE_ASSET__R3YugvlM__"